import { render, staticRenderFns } from "./CardTableV2.vue?vue&type=template&id=06fcb589&scoped=true"
import script from "./CardTableV2.vue?vue&type=script&lang=js"
export * from "./CardTableV2.vue?vue&type=script&lang=js"
import style0 from "./CardTableV2.vue?vue&type=style&index=0&id=06fcb589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcb589",
  null
  
)

export default component.exports